export default {
  items: [
    {
      name: "Change Primary Contact Requests",
      url: "/change-phone-requests",
      icon: "fa fa-dashboard fa-lg",
      attributes: { "data-cy": "change-phone-requests" },
    },
    {
      name: "Recovery Requests",
      url: "/recovery-requests",
      icon: "fa fa-dashboard fa-lg",
      attributes: { "data-cy": "recovery-requests" },
    },
  ],
};
